import { GetReferralJobsParams } from "@type/payment";
import { getCookie } from "@util/cookie";
import axios from "axios";

const apiURL = import.meta.env.VITE_TALENT_AI_BE_BASE_URL;

export const getUserReferralJobs = async (
  params: GetReferralJobsParams
): Promise<any> => {
  const token = getCookie("authToken");
  return await axios({
    url: `${apiURL}/payment/referral`,
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    params: params,
    timeout: 300000, // 15 second timeout
  });
};

export const stripeAccountConnect = async (country: string): Promise<any> => {
  const token = getCookie("authToken");
  return await axios({
    url: `${apiURL}/payment/stripe/connect`,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: {
      country: country,
    },
    timeout: 300000, // 15 second timeout
  });
};

export const getStripeAccount = async (): Promise<any> => {
  const token = getCookie("authToken");
  return await axios({
    url: `${apiURL}/payment/stripe/account`,
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    timeout: 300000, // 15 second timeout
  });
};

export const stripeConnectOauth = async (code: string): Promise<any> => {
  const token = getCookie("authToken");
  return await axios({
    url: `${apiURL}/payment/stripe/oauth`,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: {
      token: code,
    },
    timeout: 300000, // 15 second timeout
  });
};

export const stripeDisconnect = async (): Promise<any> => {
  const token = getCookie("authToken");
  return await axios({
    url: `${apiURL}/payment/stripe/disconnect`,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    timeout: 300000, // 15 second timeout
  });
};
